const tagRegexp = /\[([^=]+)=(.+)\]/;

const removeHtmlTags = (str) => str.replace(/<(.|\n)*?>/g, '');

const parseTags = (event) => {
  let description = event.description
    .replaceAll('<br>', '\n')
    .replaceAll('&nbsp;', ' ');

  description = removeHtmlTags(description).replaceAll('][', ']\n[');

  const findTagsRegexp = new RegExp(tagRegexp, 'igm');
  const matches = description.match(findTagsRegexp);

  if (matches) {
    const result = matches.reduce((acc, item) => {
      const [, key, value] = item.match(new RegExp(tagRegexp, 'i'));
      if (key && value) {
        acc[key] = value;
      }
      return acc;
    }, {});

    description = description.replaceAll(findTagsRegexp, '').trim();

    return { ...event, ...result, description }
  }

  return  { ...event, description };
}

const formatEvent = (event) => {
  let result = {
    id: event.id,
    start: new Date(event.start.date || event.start.dateTime),
    end: new Date(event.end.date || event.end.dateTime),
    title: event.summary || '',
    isRepair: false,
    description: event.description,
  };

  if (result.description) {
    result = parseTags(result)
  }

  return result;
}

export { formatEvent };
